// ponytail: the csrf cookie is unreadable when the app and API are on different
// hosts; the access JWT embeds the same csrf claim, so fall back to that.
export function jwtCsrf(token?: string): string | undefined {
	if (!token) return undefined;
	try {
		const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
		return JSON.parse(atob(b64)).csrf;
	} catch {
		return undefined;
	}
}
